import {fetchWithState, getFetchedJSON, fetchWithStateBjorn} from '~/misc/fetch';
import { getUrlQeury } from "~/misc/formatUrlquery";

export const saveAccount = async (getState, formData) => {
  const accountDataReq = {
    basicCompany: formData.company,
    basicDot:  formData.dot,
    billCycle:  formData.cycle,
    unitPrice:  formData.originPrice,
    currentCost:  formData.price,
    promotionCode:  'vip',
    billFirstname:  formData.firstName,
    billLastname : formData.lastName,
    billPhone:   formData.phone,
    billEmail:  formData.email,
    planSave: 0,
    manageUsers: 1
  }
  const orderData = await fetchWithState(getState, {
    url: '/tl/webCarrierPayment/saveAccount',
    method: 'POST',
    body: accountDataReq,
  }, true).then(getFetchedJSON);

  const {data : { memberId }} = orderData;
  const billInfoReq = {
    plan: 0,
    product: {
      seat_num: 1,
      origin_price: formData.originPrice,
      show_name: formData.showName,
      discount_price: formData.price,
      pay_option: {
        key: formData.key,
      },
      show_description: formData.description
    },
    sc: "User",
    billing_info: {
      email: formData.email,
      first_name:  formData.firstName,
      last_name: formData.lastName,
      phone: formData.phone,
      dot: formData.dot
    },
    tl_account_id: memberId
  }
  const billInfo = await fetchWithState(getState, {
    url: `/tl/webCarrierPayment/vip/order`,
    method: 'POST',
    body: {...billInfoReq,source:'carrier official'},
  }, true).then(getFetchedJSON);

  return { 
    orderId: billInfo.data.order_id, 
    businessCode: billInfo.data.business_code,
    userId: billInfo.data.account.account_id,
    token: billInfo.data.verify_key
  }
};


export const getPaymentInfoApi = (getState, {id, bussinessCode, orderId, verifyKey}) => {

  return fetchWithState(getState, {
    method: 'GET',
    header: {
      ["verify-key"]: verifyKey
    },
    url: `/tl/webCarrierPayment/${id}/vip/order?business_code=${bussinessCode}&order_id=${orderId}`,
  }).then(getFetchedJSON);
};

export const payOrderApi = (getState, {id, bussinessCode, orderId, token}) => {
  const query = getUrlQeury();

  return fetchWithState(getState, {
    method: 'POST',
    url: `/tl/webCarrierPayment/${id}/${bussinessCode}/order/${orderId}/pay`,
    body: {
      "distinctID": id,//userId
      "eventName": "payment",
      "props": {
        "pay successful": 1,
        "Distinct ID": id,
        source: query.from || '' // payment from where is it.
      },
      jsonParam: {
        account_id: id,
        token,
        business_code: bussinessCode,
        order_id: orderId,
        source: "carrier official", // offcial or carrier web
      }
    },
    // body: {
    //   account_id: id,
    //   token,
    //   business_code: bussinessCode,
    //   order_id: orderId,
    //   source: 'carrier official'
    // }
  }).then(getFetchedJSON);
};


// WEBPACK FOOTER //
// ./src/api/membership.js